module.exports = __webpack_public_path__ + "static/media/academic head.231fc591.svg";